(function () {
	'use strict';

	angular
		.module('invesfleet')
        .factory('errorManagerService', errorManagerService);

    errorManagerService.$inject = ['$http', '$q', 'authorization'];

    function errorManagerService($http, $q, authorization) {
		var service = {
            initialize: initialize,
            isValid: isValid
        };

		return service;

        var directiveArray = [];

        function initialize() {
            clear();
            fillDirectiveArray(); 
        }

        function isValid() {
            var anyNotValid = false;
            //console.log(directiveArray[1].validity.valid);
            for (var i = 0; i < directiveArray.length; i++) {                
                var state = directiveArray[i].validity;
                if (!state.valid) {
                   // console.log(state);
                    anyNotValid = true;
                    break;
                }
            }

            if (anyNotValid) {
                $(document).trigger('validate-error');
            }

            return !anyNotValid;
        }

        function clear() {
            directiveArray = []; 
        }

        function fillDirectiveArray() {
            directiveArray = $('[validate]');
        }

	}

})();